import { render, staticRenderFns } from "./OrderLifecycleReport.vue?vue&type=template&id=5b5bb8fe&"
import script from "./OrderLifecycleReport.vue?vue&type=script&lang=js&"
export * from "./OrderLifecycleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports